import { render, staticRenderFns } from "./ActivityPagination.vue?vue&type=template&id=dc5a1a50&scoped=true"
import script from "./ActivityPagination.vue?vue&type=script&lang=js"
export * from "./ActivityPagination.vue?vue&type=script&lang=js"
import style0 from "./ActivityPagination.vue?vue&type=style&index=0&id=dc5a1a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5a1a50",
  null
  
)

export default component.exports